import React, { FC, useState } from 'react'
import Modal from 'react-modal'
import { ConnectedProps, connect } from 'react-redux'

import { Button, FormInputNumber, FormInputSelect, FormInputText } from 'Components'
import HeaderSmallModal from 'Components/HeaderSmallModal/HeaderSmallModal'
import { JournalEnergyRecord, MealCategory, allMealCategories } from 'Models'
import { updateJournalEnergyRecordAction } from 'ReduxStore/journalEnergyRecords'
import { Formatter } from 'Utils'
import { modalZIndexPriority } from 'Utils/zIndexPriority'

const mapDispatchToProps = {
  updateJournalEnergyRecord: updateJournalEnergyRecordAction
}

const connector = connect(null, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  isOpen?: boolean
  onClose: () => void
  journalEnergyRecord?: JournalEnergyRecord
  addJournalEnergyRecord?: (description: string, energy: number, mealCategory: MealCategory) => void
  resetOnClose?: boolean
}

const AddEnergyRecord: FC<Props> = ({
  isOpen,
  onClose,
  resetOnClose = false,
  journalEnergyRecord,
  addJournalEnergyRecord,
  updateJournalEnergyRecord
}: Props) => {
  const [mealCategory, setMealCategory] = useState<MealCategory>(
    (journalEnergyRecord && journalEnergyRecord.mealCategory) || 'BREAKFAST'
  )

  const [energy, setEnergy] = useState<number | undefined>(
    (journalEnergyRecord && journalEnergyRecord.energy) || undefined
  )

  const [description, setDescription] = useState(() => (journalEnergyRecord && journalEnergyRecord.description) || '')

  const handleClose = (): void => {
    if (resetOnClose) {
      setMealCategory('BREAKFAST')
      setEnergy(undefined)
      setDescription('')
    }
    onClose()
  }

  const onSubmit = (): void => {
    if (energy && energy > 0 && description && description.length > 0 && mealCategory) {
      if (!journalEnergyRecord) {
        addJournalEnergyRecord && addJournalEnergyRecord(description, energy, mealCategory)
      } else {
        updateJournalEnergyRecord({
          id: journalEnergyRecord.id,
          energy,
          description,
          mealCategory
        })
      }
    }
    handleClose()
  }

  const isSubmitDisabled = energy === undefined || description === ''

  const formFields = (
    <>
      <div className="col-12 col-lg-6">
        <FormInputSelect
          name="mealCategory"
          label="Mahlzeit"
          items={allMealCategories}
          selectedKey={mealCategory}
          labelExtractor={(value) => Formatter.formatMealCategory(value as MealCategory)}
          onChange={(value) => setMealCategory(value as MealCategory)}
        />
      </div>
      <div className="col-12 col-lg-6">
        <FormInputNumber name="energy" label="kcal" value={energy} onChange={setEnergy} />
      </div>
      <div className="col-12">
        <FormInputText name="description" label="Beschreibung" value={description} onChange={setDescription} />
      </div>
    </>
  )

  const SubmitButton: React.FC = () => {
    return (
      <Button id="submitJournalEnergyRecord" onClick={onSubmit} disabled={isSubmitDisabled}>
        {journalEnergyRecord ? 'Speichern' : 'Hinzufügen'}
      </Button>
    )
  }

  const CancelButton: React.FC = () => {
    return (
      <Button type="button" theme="secondary" onClick={handleClose}>
        Abbrechen
      </Button>
    )
  }

  if (isOpen !== undefined) {
    return (
      <Modal style={modalZIndexPriority} isOpen={isOpen} onRequestClose={handleClose} ariaHideApp={false}>
        <div className="modal is-small p-0 bg-white ">
          <HeaderSmallModal onClose={handleClose}>
            <h2>Direkten Eintrag bearbeiten</h2>
          </HeaderSmallModal>

          <div className="row px-3 pt-2">{formFields}</div>

          <div className="row px-3 pb-3">
            <div className="col-12 col-sm-6">
              <CancelButton />
            </div>

            <div className="col-12 col-sm-6">
              <SubmitButton />
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  return (
    <div className="row">
      {formFields}
      <div className="col-12">
        <SubmitButton />
      </div>
    </div>
  )
}

export default connector(AddEnergyRecord)
